/**
 * @param {string} date ISO 8601 format (e.g., 2023-02-01T00:00:00.000Z)
 * @returns {string} Short formatted date(e.g., 2/3/2023)
 */
export default function formatShortDate(date) {
  return new Date(Date.parse(date)).toLocaleDateString('en-US', {
    timeZone: 'UTC'
  });
}

/**
 * @param {string | number} timestamp Unix timestamp (e.g., 1721433600)
 * @returns {string} Short formatted date (e.g., 2/3/2023)
 */
export function formatShortDateFromTimestamp(timestamp) {
  var date = new Date(parseInt(timestamp) * 1000);
  return date.toLocaleDateString('en-US', {
    timeZone: 'UTC'
  });
}

/**
 * @param {string | number} timestamp Unix timestamp (e.g., 1721433600)
 * @returns {string} Short formatted date (e.g., 2023-02-03)
 */
export function formatShortDate2FromTimestamp(timestamp) {
  var usFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var parsedDate = new Date(parseInt(timestamp) * 1000);
  var year = parsedDate.getUTCFullYear();
  var month = String(parsedDate.getUTCMonth() + 1).padStart(2, '0');
  var day = String(parsedDate.getUTCDate()).padStart(2, '0');
  return usFormat ? "".concat(month, "/").concat(day, "/").concat(year) : "".concat(year, "-").concat(month, "-").concat(day);
}
//# sourceMappingURL=formatShortDate.js.map